export const DIAGRAMS = {
  CAR_RENTAL_DAYS: 'Car rental days',
  REVENUE: 'Revenue',
  REVENUE_PER_DAY: 'Revenue per day',
  REVENUE_PER_INIT: 'Revenue per reservation',
  RESERVATIONS: 'Reservations',
  RENTAL_DAYS: 'Rental days',
  TOTAL_REVENUE: 'Total revenue',
}
export const CAR_RENTAL_DAYS_FIELDS = {
  DATE: 'Date',
  COMPLETED: 'Completed',
  SCHEDULED: 'Scheduled',
}

export const TOTAL = 'TOTAL'
export const TOOLTIP = 'All data is displayed based on selected dates.'

export const REVENUE_PER_DAY_TABLE_ITEMS = [
  CAR_RENTAL_DAYS_FIELDS.DATE,
  DIAGRAMS.REVENUE_PER_DAY,
  DIAGRAMS.REVENUE,
  DIAGRAMS.RENTAL_DAYS,
]

export const DASHBOARD_TABS = {
  CAR_RENTAL_DAY: DIAGRAMS.CAR_RENTAL_DAYS,
  FINANCIAL_INFO: 'Financial info',
}

export const DASHBOARD_SUB_TABS = {
  PER_DAY: 'Revenue per day',
  PER_UNIT: 'Revenue per unit',
  REVENUE: 'Total revenue',
}

export const CAR_RENTAL_TABLE_ITEMS = [
  CAR_RENTAL_DAYS_FIELDS.DATE,
  CAR_RENTAL_DAYS_FIELDS.COMPLETED,
  CAR_RENTAL_DAYS_FIELDS.SCHEDULED,
]
export const REVENUE_TABLE_ITEMS = ['Car type', 'Revenue', 'Reservations']
export const REVENUE_PER_UNIT_TABLE_ITEMS = [
  'Car type',
  'Revenue per reservation',
  'Revenue',
  'Reservations',
]

export const DASHBOARD_WIDGET = {
  PREVIOUS_PERIOD: 'vs previous period',
  TOOLTIP_WITH_VALUE:
    'Calculations are made in comparison with the previous period of the same duration',
  TOOLTIP_WITHOUT_VALUE:
    'Results can only be shown if the value for the previous period is greater than zero.',
}

export const INFO_BLOCK = {
  VOLUMES: {
    TITLE: 'Volumes',
    SUBTITLE: 'Natural units per selected period',
    RESERVATIONS: 'reservations',
    RENTAL_DAYS: 'rental days',
  },
  REVENUE: {
    TITLE: 'Revenue',
    SUBTITLE: ' per selected period',
  },
}

export const RESERVATION_SCHEDULE_DIAGRAM = {
  TITLE: 'Reservations schedule',
  TOOLTIP:
    'Data is displayed based on completed and scheduled bookings. To see only scheduled bookings, select a period in the future.',
}

export const NOT_AVAILABLE = 'N/A'

export const REVENUE_PER_CAR_CLASS_DIAGRAM = {
  TITLE: 'Estimated revenue',
  SUBTITLE: 'Per car class',
}

export const REVENUE_PER_CAR_DIAGRAM = {
  TITLE: 'Revenue per car',
  SUBTITLE: 'Monthly average per car class',
}
